module.exports = __webpack_public_path__ + "img/school-news.8005448b.svg";